// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from '/home/ckpt/workspace/front_package_tools_online_正式_pro/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelDepartment0 from '/home/ckpt/workspace/front_package_tools_online_正式_pro/src/models/department.ts';
import ModelGames1 from '/home/ckpt/workspace/front_package_tools_online_正式_pro/src/models/games.ts';
import ModelGlobal2 from '/home/ckpt/workspace/front_package_tools_online_正式_pro/src/models/global.ts';
import ModelLogin3 from '/home/ckpt/workspace/front_package_tools_online_正式_pro/src/models/login.ts';
import ModelResource4 from '/home/ckpt/workspace/front_package_tools_online_正式_pro/src/models/resource.ts';
import ModelRole5 from '/home/ckpt/workspace/front_package_tools_online_正式_pro/src/models/role.ts';
import ModelSetting6 from '/home/ckpt/workspace/front_package_tools_online_正式_pro/src/models/setting.ts';
import ModelUploadProgress7 from '/home/ckpt/workspace/front_package_tools_online_正式_pro/src/models/uploadProgress.ts';
import ModelUser8 from '/home/ckpt/workspace/front_package_tools_online_正式_pro/src/models/user.ts';
import ModelPeople9 from '/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Access/People/models/people.ts';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'department', ...ModelDepartment0 });
app.model({ namespace: 'games', ...ModelGames1 });
app.model({ namespace: 'global', ...ModelGlobal2 });
app.model({ namespace: 'login', ...ModelLogin3 });
app.model({ namespace: 'resource', ...ModelResource4 });
app.model({ namespace: 'role', ...ModelRole5 });
app.model({ namespace: 'setting', ...ModelSetting6 });
app.model({ namespace: 'uploadProgress', ...ModelUploadProgress7 });
app.model({ namespace: 'user', ...ModelUser8 });
app.model({ namespace: 'people', ...ModelPeople9 });
  return app;
}

export function getApp() {
  return app;
}

/**
 * whether browser env
 * 
 * @returns boolean
 */
function isBrowser(): boolean {
  return typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (isBrowser()) {
      _onCreate()
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    let app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
